import { HexColor } from '@gn-audio/jss-components/utils';

import { FamilyGroup } from 'api/productCatalogueApi';
import { getGroupAttributesObject } from 'composables/Product/Buy/customizerHelpers';

export const getProductColorHex = (group: FamilyGroup): HexColor | undefined => {
  const spec = getGroupAttributesObject(group);
  const [productColor] = spec.Product_Mobcolorhex ?? [];
  return productColor ? `#${productColor}` : undefined;
};

export const getBrandColorName = (group: FamilyGroup): string | undefined => {
  const spec = getGroupAttributesObject(group);
  const [brandColor] = spec.Product_BrandColorPublicWeb ?? [];
  return brandColor;
};
